// extracted by mini-css-extract-plugin
export default {"errorBlock":"CompareModeSameModelsError_errorBlock__HZpGw","root":"CompareModeSameModelsError_root__jgoMz"};